/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingExpertDto } from './BookingExpertDto';
import type { BookingSessionSummaryDto } from './BookingSessionSummaryDto';
import type { i } from './i';
export type ClientBookingItemDto = {
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking type
     */
    bookingType: string;
    /**
     * Session type
     */
    sessionType?: string | null;
    /**
     * Session mode (online/offline/location)
     */
    mode?: ClientBookingItemDto.mode;
    /**
     * Booking status
     */
    status: ClientBookingItemDto.status | null;
    /**
     * Latest cancellation dispute status for this booking
     */
    disputeStatus?: ClientBookingItemDto.disputeStatus;
    /**
     * Booking cancelled timestamp
     */
    cancelledAt?: string | null;
    /**
     * Who cancelled the booking (client/expert/admin)
     */
    cancelledBy?: string | null;
    /**
     * Cancellation reason
     */
    cancellationReason?: string | null;
    /**
     * Cancellation type
     */
    cancellationType?: ClientBookingItemDto.cancellationType;
    /**
     * Service type name
     */
    serviceName?: string | null;
    /**
     * Sub-service name
     */
    subServiceName?: string | null;
    /**
     * Package name
     */
    packageName?: string | null;
    /**
     * Total amount (Decimal, serializes as string)
     */
    totalAmount: i;
    /**
     * Package validity end date
     */
    validUntil?: string | null;
    /**
     * Last session scheduled start time (for inactive bookings)
     */
    lastSessionAt?: string | null;
    expert: BookingExpertDto;
    sessions: BookingSessionSummaryDto;
};
export namespace ClientBookingItemDto {
    /**
     * Session mode (online/offline/location)
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Booking status
     */
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
    /**
     * Latest cancellation dispute status for this booking
     */
    export enum disputeStatus {
        PENDING = 'pending',
        IN_REVIEW = 'in_review',
        RESOLVED = 'resolved',
        DECLINED = 'declined',
    }
    /**
     * Cancellation type
     */
    export enum cancellationType {
        CLIENT_INITIATED = 'client_initiated',
        EXPERT_INITIATED = 'expert_initiated',
        ADMIN_INITIATED = 'admin_initiated',
        NO_SHOW = 'no_show',
        SYSTEM = 'system',
    }
}

